import { render, staticRenderFns } from "./LabelledSwatchSelect.vue?vue&type=template&id=3fdf11da&"
import script from "./LabelledSwatchSelect.vue?vue&type=script&lang=js&"
export * from "./LabelledSwatchSelect.vue?vue&type=script&lang=js&"
import style0 from "./LabelledSwatchSelect.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SwatchSelect: require('/opt/build/repo/storefront/components/molecules/Product/SwatchSelect.vue').default})
